/**
 * @file
 * Shop Equalizers.
 */

// Equalize collections listing.
let $collections = $('.collection-listing', context);

$collections.once('collection-listing-equalize').each(function() {
  let $this = $(this);

  $this.find('.views-row').attr('data-equalizer-watch', 'equalize-collections');
  $this.attr({
    'data-equalizer': 'equalize-collections',
    'data-equalize-on': 'small'
  });
});
